import { forwardRef, type HTMLAttributes } from 'react';
import { factoryTypesArray, type FactoryTypeText } from '@common/types/factory';
import { plantTypesArray, type PlantTypeText } from '@common/types/plant';
import {
  resourceTypesArray,
  type ResourceTypeText,
} from '@common/types/resource';
import {
  factoryImages,
  type ImageFormats,
  plantImages,
  resourceImages,
} from '@components/helpers/imagesImports';
import { motion } from 'framer-motion';

interface ResourceImageProps extends HTMLAttributes<HTMLDivElement> {
  size: number | string;
  kind: ResourceTypeText | PlantTypeText | FactoryTypeText;
  actionType?: 'Build' | 'Tap' | 'Sell';
  direction?: 'left' | 'right';
}

const ResourceImage = forwardRef<HTMLDivElement, ResourceImageProps>(
  ({ size, kind, actionType, direction, ...props }, ref) => {
    let image;

    if (actionType === 'Build') {
      if (resourceTypesArray.includes(kind as ResourceTypeText)) {
        image = resourceImages[kind as ResourceTypeText].build;
      } else if (plantTypesArray.includes(kind as PlantTypeText)) {
        image = plantImages[kind as PlantTypeText].build;
      } else if (factoryTypesArray.includes(kind as FactoryTypeText)) {
        image = factoryImages[kind as FactoryTypeText].build;
      }
    } else {
      if (resourceTypesArray.includes(kind as ResourceTypeText)) {
        image = resourceImages[kind as ResourceTypeText].icon as ImageFormats;
      } else if (plantTypesArray.includes(kind as PlantTypeText)) {
        image = plantImages[kind as PlantTypeText].icon as ImageFormats;
      }
    }

    return (
      <div ref={ref} {...props} style={{ width: size, height: size }}>
        <picture>
          <source
            srcSet={
              direction && image?.webpRight ? image.webpRight : image?.webp
            }
            type="image/webp"
          />
          <img
            src={direction && image?.pngRight ? image.pngRight : image?.png}
            alt="task"
          />
        </picture>
      </div>
    );
  },
);

const MotionResourceImage = motion.create(ResourceImage);

export { MotionResourceImage, ResourceImage };
